import React, { Component, PropTypes } from 'react';
import AddButtonView from './AddButtonView';
import TablePanelMulti from './TablePanelMulti';

class TablePanelViewMulti extends Component {
    render() {
        return (
            <div>
                <div>
                    <h3>{this.props.headline}</h3>
                    <TablePanelMulti
                        columns={this.props.columns}
                        changeConfigRow={this.props.changeConfigRow}
                        deleteConfigRow={this.props.deleteConfigRow}
                        editConfigRow={this.props.editConfigRow}
                        id={this.props.id + '-panel'}
                        isDisabled={this.props.isDisabled}
                        list={this.props.list}
                        single={this.props.single}
                    />
                    <AddButtonView
                        clearCode={this.props.clearCode}
                        clearComments={this.props.clearComments}
                        isDisabled={this.props.isDisabled}
                        moreButtons={this.props.moreButtons}
                        onSubmit={this.props.onSubmit}
                    >
                        {this.props.children}
                    </AddButtonView>
                </div>
            </div>
        );
    }
}

TablePanelViewMulti.propTypes = {
    buttonComment: PropTypes.string,
    children: PropTypes.element,
    columns: PropTypes.array,
    content: PropTypes.array,
    contentLevel: PropTypes.object,
    headline: PropTypes.string,
    id: PropTypes.string,
    onDispatch: PropTypes.func,
    onShowInfo: PropTypes.func,
    onSubmit: PropTypes.func
};

export default TablePanelViewMulti;



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/TablePanelViewMulti.js